/*
 * © 2020 Microsoft. All rights reserved.
 */

define('MenuUI/MenuTile',['pixi', 'absolute', 'lodash', 'MenuUI/DropShadow'],

    function (PIXI, Absolute, _, DropShadow, mod1) {

        var MenuTile = function (config) {
            var defaultConfig = {
                userData: null,
                imageScale: 1,
                image: '',
                icon: '',
                label: '',
                action: null,
                letterStyle: {
                    font: '' + Absolute.ScreenMetrics.getResScale() * 32 + "px Arial",
                    fontFamily: 'segoeLight',
                    fill: '#ffffff',
                    align: 'left'
                },
                iconPosition: {
                    x: 0,
                    y: 0
                },
                labelPosition: {
                    x: Absolute.Coords.x(80),
                    y: 0
                },
                labelPadding: Absolute.Coords.y(15),
                labelOffset: Absolute.Coords.y(14),
                dropShadow: true,
                hoverBox: true,
                disableOnClick: true
            };
            this.initMenuTile(_.extend(defaultConfig, config));
        };

        MenuTile.constructor = MenuTile;
        MenuTile.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        MenuTile.prototype.initMenuTile = function (config) {
            PIXI.DisplayObjectContainer.call(this);
            this.config = config;
            this.startPos = new PIXI.Point();
            this.moveThreshold = Absolute.Coords.x(15);
            this.down = false;

            if (this.config.image instanceof PIXI.Texture) {
                this.image = new PIXI.Sprite(this.config.image);
                this.image.scale.x = this.image.scale.y = Absolute.ScreenMetrics.getResScale();
            } else if (typeof this.config.image === 'string' && !this.config.imageExternalUrl) {
                this.image = PIXI.Sprite.fromFrame(this.config.image);

            } else if (this.config.image instanceof PIXI.DisplayObject) {
                this.image = this.config.image;
            }
            if (this.image) {
                this.addChild(this.image);
            } else if (this.config.imageExternalUrl) {
                var imageLoader = new PIXI.ImageLoader(this.config.image, true),
                    self = this;

                function onLoadImage() {
                    self.image = PIXI.Sprite.fromFrame(self.config.image);
                    self.image.width = self.config.width * this.config.imageScale;
                    self.image.height = self.config.height * this.config.imageScale;
                    self.addChild(self.image);
                    imageLoader.removeEventListener('loaded', onLoadImage);
                }

                imageLoader.addEventListener('loaded', onLoadImage);
                imageLoader.load();
            }

            this._hasFocus = false;
            this.focusIndicator = new PIXI.Graphics();
            this.focusIndicator.lineStyle(Absolute.Coords.x(3), 0xFFFFFF);
            var margin = Absolute.Coords.x(-4);
            // Daily challenge and star club add a 70 pixel tall bar at the top that messes with the indicator.
            const focusHeight = !!config.page ? (this.height - 2 * margin) + Absolute.Coords.y(70) : this.height - 2 * margin;
            this.focusIndicator.drawRect(margin, margin, this.width - 2 * margin, focusHeight);

            var labelYOffset = 0;
            if (this.config.icon !== '') {
                this.icon = PIXI.Sprite.fromFrame(this.config.icon);
                this.icon.x = this.config.iconPosition.x;
                this.icon.y = this.config.iconPosition.y || this.height - this.icon.height;
                labelYOffset = this.config.labelPosition.y || this.icon.y + this.config.labelOffset;
                this.config.labelPosition.x = this.icon.x + this.icon.width;
            }

            if (this.config.label && this.config.label !== "") {
                var key = 'tiles.' + this.config.label;
                var text = Absolute.StringManager(key);
                if (text === key) {
                    text = this.config.label;
                }
                if(this.config.isMainMenu) {
                    this.config.letterStyle.dropShadow = true;
                    this.config.letterStyle.dropShadowColor = '#000000';
                    this.config.letterStyle.dropSahdowAngle =  0;
                    this.config.letterStyle.dropShadowDistance = 0.8;
                }

                var labelText = new PIXI.Text(text, this.config.letterStyle);
                var fontSize = Absolute.StringManager.extractNumbersFromString(this.config.letterStyle.font);
                var isBold = this.config.letterStyle.font.toLowerCase().indexOf('bold') !== -1;
                var maxWidth = 0,
                    anchorY = 0;
                if (this.config.isMainMenu || this.config.isDailyChallenge) {
                    maxWidth = this.config.isMainMenu ? this.width - Absolute.Coords.x(100) : this.width - Absolute.Coords.x(40);
                    anchorY = 0.5;
                    this.config.labelOffset = Absolute.Coords.y(35);
                    labelYOffset = this.config.labelPosition.y || this.icon.y + this.config.labelOffset;
                } else {
                    maxWidth = this.config.maxWidth || this.width - Absolute.Coords.x(105);
                }
                Absolute.StringManager.shrinkToFit(labelText, fontSize, isBold ? 'Bold ' : '', maxWidth);
                this.label = new PIXI.Sprite(labelText.generateTexture());
                this.label.anchor.set(0, anchorY);
                this.label.x = this.config.labelPosition.x;
                this.label.y = this.config.labelPosition.y || labelYOffset;
            }


            if (this.config.hoverBox) {
                var hoverGraphic = new PIXI.Graphics(),
                    lineWeight = Absolute.Coords.x(4);
                hoverGraphic.beginFill(0xFFFFFF, 0);
                hoverGraphic.lineStyle(lineWeight, 0xFFFFFF, 1);
                hoverGraphic.drawRect(0, 0, this.width, this.height);
                hoverGraphic.endFill();
                this.hover = hoverGraphic;
                this.hover.alpha = 0.01; // stupid hack to fix jumpy hover graphic
            }

            this.mouseover = function () {
                if (this.hover) {
                    this.hover.visible = true;
                    this.hover.alpha = 1;
                }
            };

            this.mouseout = function () {
                if (this.hover) {
                    this.hover.visible = false;
                }
            };

            if (this.config.dropShadow) {
                var dropShadow = new DropShadow({
                    baseWidth: this.width,
                    baseHeight: this.height
                });
                this.dropShadow = dropShadow;
                this.addChildAt(dropShadow, 0);
            }

            if (this.label) {
                this.addChild(this.label);
            }
            if (this.config.icon !== '') {
                this.addChild(this.icon);
            }
            if (this.hover) {
                this.addChild(this.hover);
            }

            this.bindInteraction(this, this.handleClick);

        };

        MenuTile.prototype.bindInteraction = function (sprite, handler) {

            sprite.interactive = true;
            sprite.buttonMode = true;

            sprite.mousedown = function (evt) {
                // fix an issue on iOS devices in desktop mode
                if (Absolute.Platform._isMac() && Absolute.Platform._isIOS()) {
                    return;
                }
                this.clickCanceled = false;
                this.startPos = evt.global.clone();
                this.down = true;
            }.bind(this);

            sprite.mouseup = function (evt) {
                // fix an issue on iOS devices in desktop mode
                if (Absolute.Platform._isMac() && Absolute.Platform._isIOS()) {
                    return;
                }

                // don't trigger if the cursor moved (we are dragging)
                if (!this.clickCanceled && this.down) {
                    this.handleAction(handler);
                }
                this.clickCanceled = false;
                this.down = false;
            }.bind(this);

            sprite.mousemove = function (evt) {
                // fix an issue on iOS devices in desktop mode
                if (Absolute.Platform._isMac() && Absolute.Platform._isIOS()) {
                    return;
                }
                if (this.down) {
                    if (Math.abs(this.startPos.x - evt.global.x) > this.moveThreshold || Math.abs(this.startPos.y - evt.global.y) > this.moveThreshold) {
                        this.clickCanceled = true;
                    }
                }
            }.bind(this);

           sprite.touchstart = function (evt) {                
                this.clickCanceled = false;
                this.startPos = evt.global.clone();
                this.down = true;
            }.bind(this);

            sprite.touchend = function (evt) {                
                // don't trigger if the cursor moved (we are dragging)
                if (!this.clickCanceled && this.down) {
                    this.handleAction(handler);
                }
                this.clickCanceled = false;
                this.down = false;
            }.bind(this);

            sprite.touchmove = function (evt) {                
                if (this.down) {
                    if (Math.abs(this.startPos.x - evt.global.x) > this.moveThreshold || Math.abs(this.startPos.y - evt.global.y) > this.moveThreshold) {
                        this.clickCanceled = true;
                    }
                }
            }.bind(this);

        };

        MenuTile.prototype.handleAction = function (handler) {
            if (!this.interactive) {
                return;
            }
            if (this.config.disableOnClick) {
                this.interactive = false;
            }
            Absolute.AudioManager.playSound('button');
            handler.call(this);
        };

        MenuTile.prototype.handleClick = function () {
            if (typeof this.config.action === 'function') {
                this.config.action(this.config.userData);
            }
        };

        MenuTile.prototype.handleActivate = function () {
            this.handleClick();
        };

        MenuTile.prototype.onShow = function () {
            this.interactive = true;
        };

        Object.defineProperty(MenuTile.prototype, "width", {
            get: function () {
                var width = 0;
                if (this.image) {
                    width = this.image.width;
                } else if (this.config.width) {
                    width = this.config.width;
                }
                return width;
            }
        });

        Object.defineProperty(MenuTile.prototype, "height", {
            get: function () {
                var height = 0;
                if (this.image) {
                    height = this.image.height;
                } else if (this.config.height) {
                    height = this.config.height;
                }
                return height;
            }
        });

        MenuTile.prototype._focusChanged = function () {
            if (this._hasFocus) {
                this.addChild(this.focusIndicator);
            } else {
                if (this.children.indexOf(this.focusIndicator) != -1) {
                    this.removeChild(this.focusIndicator);
                }
            }
        };

        Object.defineProperty(MenuTile.prototype, "focus", {
            get: function () {
                return this._hasFocus;
            },
            set: function (value) {
                this._hasFocus = value;
                this._focusChanged();
                return value;
            }
        });

        return MenuTile;

    });

